import { render, staticRenderFns } from "./ActiveName.vue?vue&type=template&id=7fc11ef9&scoped=true&"
import script from "./ActiveName.vue?vue&type=script&lang=js&"
export * from "./ActiveName.vue?vue&type=script&lang=js&"
import style0 from "./ActiveName.vue?vue&type=style&index=0&id=7fc11ef9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc11ef9",
  null
  
)

export default component.exports